<div class="search-bar">

  <div class="item-type-btn" *ngIf="showMedias==true">
    <app-dropdown [items]="itemTypes" [selectedItem]="selectedItemType" (onItemSelected)="itemTypeChanged($event)"></app-dropdown>
  </div>

  <input type="text" class="search-input" [placeholder]="placeholder" (keyup)="onKeyUp($event)" [value]="query" appAutofocus [autoFocusOn]="autoFocus" (focus)="onFocus()">
  <button class="search-button" (click)="searchClick()">
    <img *ngIf="!isDarkTheme()" [alt]="getSearchAlt()" class="magnifier-icon" src="./assets/images/flyout_lupe.png">
    <img *ngIf="isDarkTheme()" [alt]="getSearchAlt()" class="magnifier-icon" src="./assets/images/flyout_lupe_white.png">
  </button>
  
  <app-search-suggestions *ngIf="showSuggestions && activateSuggestions" [suggestions]="suggestions" [inputValue]="inputValue" (onSearchClicked)="searchClick()"></app-search-suggestions>

</div>

<div class="mobile-media-dropdown" *ngIf="showMedias==true">
  <div class="media-selection-text">{{getString('mediaSelection')}}</div>
  <div class="item-type-btn" ><app-dropdown [items]="itemTypes" [selectedItem]="selectedItemType" (onItemSelected)="itemTypeChanged($event)"></app-dropdown></div>
</div>